import { Dispatch } from 'redux';
import api from './api'; // your API helper

// ==================
// Types
// ==================

export interface SocialNetwork {
  uuid: string;
  name: string;
  linkFR: string;
  linkUS: string;
  linkES: string;
  linkIT: string;
  order: number;
  activated: boolean;
  createdAt: string;
  updatedAt: string;
  [key: string]: string | number | boolean | undefined;
}

// ==================
// Action Types
// ==================

const GET_SNS = '[SETTINGS] GET SNS';
const GET_SNS_SUCCESS = '[SETTINGS] GET SNS SUCCESS';
const GET_SNS_FAILURE = '[SETTINGS] GET SNS FAILURE';

interface GetSNSAction {
  type: typeof GET_SNS;
}

interface GetSNSSuccessAction {
  type: typeof GET_SNS_SUCCESS;
  payload: SocialNetwork[];
}

interface GetSNSFailureAction {
  type: typeof GET_SNS_FAILURE;
  error: string;
}

type SettingsActionTypes = GetSNSAction | GetSNSSuccessAction | GetSNSFailureAction;

// ==================
// State Type
// ==================

interface SettingsState {
  loading: boolean;
  socialNetworks: SocialNetwork[];
  error: string | null;
}

const initialState: SettingsState = {
  loading: false,
  socialNetworks: [],
  error: null,
};

// ==================
// Reducer
// ==================

const settingsReducer = (
  state = initialState,
  action: SettingsActionTypes
): SettingsState => {
  switch (action.type) {
    case GET_SNS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_SNS_SUCCESS:
      return {
        ...state,
        loading: false,
        socialNetworks: action.payload,
        error: null,
      };
    case GET_SNS_FAILURE:
      return {
        ...state,
        loading: false,
        socialNetworks: [],
        error: action.error,
      };
    default:
      return state;
  }
};

export default settingsReducer;

// ==================
// Async Action
// ==================

export const getSocialNetworks = (filter: 'true' | 'false' | '' = '') => async (
  dispatch: Dispatch<SettingsActionTypes>
) => {
  dispatch({ type: GET_SNS });
    try {
            const response = await api.get('/api/social-networks', {
            params: filter ? { filter } : {},
        });
        dispatch({
            type: GET_SNS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: GET_SNS_FAILURE,
            error: (error as Error).message,
        });
    }
};
